import { registrationPaths, semiRegistrationPaths } from '~/constants';

export const isRegistrationPath = () => registrationPaths.includes(location.pathname);

export const isSemiRegistrationPath = () => semiRegistrationPaths.includes(location.pathname);
